var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"QHcheckboxGroup",class:{ disabled: _vm.disabled }},[_c('CheckboxGroup',{on:{"on-change":_vm.getValue},model:{value:(_vm.values),callback:function ($$v) {_vm.values=$$v},expression:"values"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }